import { Box, Flex, TextButton } from '@modusign/design-system';
import { useTranslation } from 'react-i18next';

interface UploadedFileInformationProps {
  fileName: string;
  onReset: () => void;
}

export default function UploadedFileInformation({
  fileName,
  onReset,
}: UploadedFileInformationProps) {
  const { t } = useTranslation();

  return (
    <Flex
      bg="lightGray50"
      borderColor="lightGray300"
      borderRadius="4px"
      borderStyle="solid"
      borderWidth="1px"
      justifyContent="space-between"
      margin="auto"
      marginBottom={4}
      maxWidth="300px"
      paddingX={4}
      paddingY={3}
      width="100%"
    >
      <Box
        sx={{
          height: '16px',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
      >
        <Box
          as="i"
          className="fa fa-file"
          sx={{
            color: 'darkGray200',
            mr: '3px',
          }}
        />
        {fileName}
      </Box>
      <TextButton textDecoration="plain" onClick={onReset}>
        {t('Global-cancel')}
      </TextButton>
    </Flex>
  );
}
